import { DateInputLocalized, InfoSection, InputNumberLocalized, RegisterPaymentModal } from '@components'

import { FormItemsGroup } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useFormContext } from '../../../../../../hooks'
import { useVatDeclarationsRegisterPeriodPaymentModal } from '../../context/vatDeclarationsRegisterPaymentModalContext'
import { VatDeclarationsRegisterPeriodPaymentModalFormSchema } from '../../utils/formData'

interface ModalFormProps {
  currency: string
}

export const ModalForm = ({ currency }: ModalFormProps): ReactElement => {
  const { t } = useTranslation()
  const { Form, handlePaymentDateChange } = useVatDeclarationsRegisterPeriodPaymentModal()
  const { FormItem } = useFormContext<VatDeclarationsRegisterPeriodPaymentModalFormSchema>()

  return (
    <Form>
      <FormItemsGroup itemsInRow={5}>
        <FormItem
          itemColumnEnd={1}
          itemColumnStart={6}
          label={t('vat_declarations.register_payment_modal.form.account_label')}
          name="paymentAccount"
          render={({ field: { onChange, value, ...rest } }) => (
            <RegisterPaymentModal.AccountSelect {...rest} onSelect={onChange} selectedId={value} />
          )}
        />
        <FormItem
          itemColumnEnd={3}
          itemColumnStart={1}
          label={t('vat_declarations.register_payment_modal.form.date_label')}
          name="paymentDate"
          render={({ field: { onChange, ...rest } }) => (
            <DateInputLocalized
              {...rest}
              onChange={(date) => {
                onChange(date)
                handlePaymentDateChange(date)
              }}
            />
          )}
        />
        <FormItem
          itemColumnEnd={6}
          itemColumnStart={3}
          label={t('vat_declarations.register_payment_modal.form.amount_label')}
          name="totalAmount"
          render={({ field }) => <InputNumberLocalized {...field} disabled suffix={currency} />}
        />
      </FormItemsGroup>
      <InfoSection infoText={t('vat_declarations.register_payment_modal.info')} />
    </Form>
  )
}
